import { SelectListItemStateType } from '@app/enums/SelectListItemStateType';
import type ISelectItem from '@app/interfaces/dtos/ISelectItem';
import type { IMultiselectOption } from '@app/interfaces/dtos/IMultiselectOption';

export const toMultiselectOption = (option: IMultiselectOption | ISelectItem): IMultiselectOption => {
	if ('label' in option) return option;

	return {
		value: option.value,
		label: option.text,
		icon: option.icon,
		count: option.count,
		disabled: option.state === SelectListItemStateType.DISABLED
	};
};
